import CollapsiblePanel from './CollapsiblePanel.vue';

export default CollapsiblePanel;
export type { Props as CollapsiblePanelProps } from './CollapsiblePanel.vue';
